import { Fragment, useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Container, Row, Col, Image, Button, Form, Stack, Modal } from "react-bootstrap";
import useAxios from "axios-hooks";
import BrandContext from "./BrandContext";
import { useSignIn, useSignOut, useIsAuthenticated } from 'react-auth-kit'
import { format } from 'date-fns'

export default function LoginBulkCodes(props) {
    const isAuthenticated = useIsAuthenticated();
    const params = useParams();
    const signIn = useSignIn()
    const signOut = useSignOut()
    const nav = useNavigate();
    const [email, setEmail] = useState('');
    const [codeRequested, setCodeRequested] = useState(false)
    const [code, setCode] = useState('')
    const [msg, setMsg] = useState({})
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = (msg) => { setMsg(msg); setShow(true) };
    useEffect(() => {
        if (isAuthenticated()) {
            signOut();
        }
    }, []);

    const [{ loading: gettingCode }, executeGetCode] = useAxios(
        {
            url: '/bulk-sales/get-code',
            method: 'POST',
            baseURL: process.env.REACT_APP_AUTH_URL
        },
        { manual: true }
    )
    const [{ loading: validatingCode }, executeValidateCode] = useAxios(
        {
            url: '/bulk-sales/validate-code',
            method: 'POST',
            baseURL: process.env.REACT_APP_AUTH_URL
        },
        { manual: true }
    )

    function validateCode() {
        executeValidateCode({
            data: {
                email: email,
                verificationCode: code
            }
        })
            .then((res) => {
                if (signIn(
                    {
                        token: res.data.jwt,
                        expiresIn: 60 * 23,
                        tokenType: "Bearer",
                        authState: {
                            email: email
                        }
                    }
                )) {
                    nav(props.redirectUrl)
                } else {
                    //Throw error
                }
            })
            .catch((e) => {
                const status = e?.response?.status;
                if (status === 401) handleShow({
                    title: 'Invalid Verification Code',
                    body: 'Sorry, the verification code you entered is not correct. Please try again or request a new code.'
                })
                if (status === 403) handleShow({
                    title: 'Email Verfication Error',
                    body: 'Sorry, there was an error validating your email.'
                })
            })
            .finally(() => {

            })
    }

    function getCode() {
        executeGetCode({
            data: {
                email: email
            }
        })
            .then((r) => {
                handleShow({
                    title: 'Email Verification',
                    body: `A verification code was sent to ${email}. Copy the code, click out of this popup and enter the verification code in the field below.`
                })
                setCodeRequested(true);
            })
            .catch((e) => {
                const status = e?.response?.status;
                if (status === 403) handleShow({
                    title: 'Email Verification Error',
                    body: 'Sorry, there was an error validating your email.'
                })
            })
            .finally(() => {

            })
    }
    const handleKeypress = e => {
        if (e.keyCode === 13) { e.preventDefault() }
    };

    return (
        <BrandContext.Consumer>
            {theme =>
                <Fragment>
                    <Container fluid="md" style={{ paddingTop: "50px", paddingBottom: "50px" }}>
                        <Row>
                            <Col sm={{ span: true, order: 'first' }} xs={{ span: 12, order: 'last' }} style={{ padding: "15px" }}>
                                <p className="fw-bold" style={{ fontSize: "24px", lineHeight: "26px" }}>Access My Press Release Purchase Codes</p>
                            </Col>
                        </Row>
                        <Fragment>
                            <Row>
                                <Col md={{ span: 6, order: 3 }} style={{ padding: "15px" }} xs={{ span: 12, order: 2 }}>
                                    <p style={{ fontSize: "16px", lineHeight: "26px" }}>Did you buy bulk discount codes and need to manage them? Or need to edit any of the press releases you purchased using discount codes? Enter your email below and we will immediately send you an access code.</p>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={{ span: 6, order: 3 }} style={{ padding: "15px" }} xs={{ span: 12, order: 2 }}>
                                    <Form noValidate onSubmit={(e) => { e.preventDefault(); return false; }}>
                                        <Form.Group className="mb-3" controlId="customer.email">
                                            <Form.Label>Your Email Address</Form.Label>
                                            <Form.Control autoFocus required type="email"
                                                onChange={(e) => setEmail(e.target.value)}
                                                readOnly={gettingCode || codeRequested}
                                                onKeyUp={handleKeypress} />
                                        </Form.Group>
                                        {codeRequested &&
                                            <Form.Group className="mb-3" controlId="customer.name">
                                                <Form.Label>Verification Code</Form.Label>
                                                <Form.Control required type="text"
                                                    placeholder="Enter verification code"
                                                    onChange={event => setCode(event.target.value)}
                                                />
                                            </Form.Group>
                                        }
                                    </Form>
                                </Col>
                            </Row>
                            <Stack direction="horizontal" gap={3}>
                                {!codeRequested &&
                                    <Button onClick={() => getCode()} disabled={!email || gettingCode || validatingCode} >Next</Button>
                                }
                                {gettingCode && <div>Requesting verification code...</div>}
                                {codeRequested &&
                                    <Fragment>
                                        <Button onClick={() => validateCode()} disabled={!email || !code || gettingCode || validatingCode} >Next</Button>
                                        <Button onClick={() => setCodeRequested(false)} variant="link">Request a new code</Button>
                                    </Fragment>
                                }
                            </Stack>
                            <Row>
                                <Col md={{ span: 6, order: 3 }} style={{ padding: "15px" }} xs={{ span: 12, order: 2 }}>
                                    <div className="fw-bold" style={{ fontSize: "16px", lineHeight: "18px" }}>Need help? Looking for more codes?</div>
                                    <div style={{ fontSize: "16px", lineHeight: "18px" }}>Reach out to your Account Manager.</div>
                                </Col>
                            </Row>
                        </Fragment>
                    </Container>
                    <Modal show={show} onHide={handleClose} size="md" centered>
                        <Modal.Header closeButton>
                            <Modal.Title>{msg.title}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {msg.body}
                        </Modal.Body>
                    </Modal>
                </Fragment>
            }
        </BrandContext.Consumer>
    );
}